import React, { useEffect } from 'react';
import { LeadConfirmationModal, ListingCarouselCard } from '@dmm/lib-react-ui-components';
import { useIntl } from 'react-intl';
import { syncTranslationElements } from '../../../tppServices/translations/intlManager';
import PropTypes from 'prop-types';
import { generateSearchPath } from '../../../utils/urlHelpers/boats';
import { getTitle, getPrice } from '../../../utils/listingHelper';
import { getBoatUrl } from '../../../utils/urlHelpers/boat';
import {useTPPServices} from '../../../tppServices/tppDIHooks';
import defaultImg from '../../../icons/placeholder-image.svg';
import * as listingHelper from '../../../utils/listingHelper';
import useBranchIoMetaTag from '../../../hooks/useBranchIoMetaTag';
import { BRANCHIO_CONTENT_TYPES } from '../../../utils/branchIoEventsManager';

const BDPLeadConfirmationModal = (props) => {
  const intl = useIntl();
  const { messages, t } = syncTranslationElements(intl);
  const {
    breakpoint,
    navLinks,
    listings,
    open,
    onClose,
    customPricingOptions
  } = props;
  const {boatsConstants} = useTPPServices();
  const { BranchIoMetaTagComponent, fireBranchioMetaTag } = useBranchIoMetaTag();

  const backToSearch = navLinks?.searchUrl
    ? navLinks.searchUrl
    : generateSearchPath({});

  const getSimilarListings = (listings) => {
    return listings.map((listing) => {
      return (
        <ListingCarouselCard
        key={listing.id}
        name= {getTitle(listing)}
        price= {getPrice(listing, customPricingOptions)}
        sellerMarketingMessage= {t(messages.additionalLeads.viewDetails)}
        image={listingHelper.addResizeParams(listing.media[0]?.url, { width: 308, height: 205 }, listing.media[0]?.date?.modified, true, 'webp') || defaultImg}
        imageAlt= {getTitle(listing)}
        imageLazyLoading={true}
        hyperlinkAttributes={{
          'data-listing-id': listing.id,
          'data-reporting-click-product-id': listing.id,
          'data-reporting-click-listing-type': boatsConstants.LISTING_MULTI_CONTACT,
          href: getBoatUrl(listing),
          target: '_blank'
        }}
        />
      );
    });
  };

  useEffect(() => {
    fireBranchioMetaTag?.(BRANCHIO_CONTENT_TYPES.CONTACT_SUBMITTED);
  }, []);

  return (
    <>
      <BranchIoMetaTagComponent />
    <div
      data-testid="lead-confirmation-modal"
      className={`lead-confirmation-modal ${breakpoint === 'mobile' ? 'mobile-view' : ''}`}
    >
      <LeadConfirmationModal
        show={open}
        onClose={onClose}
        hideSeparator={breakpoint === 'mobile'}
        requestSentText={t(messages.additionalLeads.requestSent)}
        successMessage={t(messages.additionalLeads.leadSuccessMessage)}
        title={t(messages.additionalLeads.leadModalTitle)}
        subtitle={t(messages.additionalLeads.leadModalSubtitle)}
        backLinkText={t(messages.nextPrevious.backToSearch)}
        backLinkUrl={backToSearch}
      >
        {getSimilarListings(listings)}
      </LeadConfirmationModal>
    </div>
    </>
  );
};

BDPLeadConfirmationModal.propTypes = {
  breakpoint: PropTypes.string,
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string,
    searchUrl: PropTypes.string
  }),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  listings: PropTypes.array,
  customPricingOptions: PropTypes.object,
  listingType: PropTypes.string,
};

export default BDPLeadConfirmationModal;
